// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { collection, getDocs, addDoc, deleteDoc, doc, updateDoc } from "firebase/firestore";
// import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
// import { v4 as uuidv4 } from 'uuid';

// import { db, storage } from "../../Firebase/firebaseConfig";
// //import { error } from "console";


// export const fetchCategories = createAsyncThunk<any, void>("categories/fetchcategories", async (_,thunk) => {
//     try {
         
//         const querySnapshot = await getDocs(collection(db, "categories"));
//         const data = querySnapshot.docs.map(doc => ({ id: doc.id,...doc.data()}))
//          //const sortedData = data.sort(
//         //(a, b) => (a?.display_order || 0) - (b?.display_order || 0)
//       //);
//         console.log(querySnapshot,"querysnapshot");
//         //console.log(sortedData,"sorted data");
//         return data;
        
//     } catch (error) {
//         console.error(error)
//         thunk.rejectWithValue(error);
//     }
// }) 

// export const addCategory = createAsyncThunk<any,any>(
//     "categories/addCategories",
//     async ({ name, imageFile, base64Image, display_order }) => {
         
//         try {
//         let imageUrl = "";
//         if (imageFile) {
//         //   console.log("Uploading image 1:", imageFile);
//         const imageRef = ref(storage, `categories/${uuidv4()}`);
//         // const res=  await uploadBytes(imageRef, imageFile);
//         // console.log("response from upload", res)
//         //   imageUrl = await getDownloadURL(imageRef);
//         //   console.log("Image uploaded successfully. URL:", imageUrl);
//         }
    
//         const categoryData = { name, image: base64Image,display_order };
//         const docRef = await addDoc(collection(db, "categories"), categoryData);
    
//         return { id: docRef.id, ...categoryData };
//         } catch (error:any) {
//         console.error("Error uploading image:", error);
//         throw new Error(error.message);
//         }
//     }
//     );
      
    

// export const deleteCategories = createAsyncThunk("categories/deleteCategories", async (categoryId:any) => {
//        await deleteDoc(doc(db, "categories", categoryId));       
//        return categoryId;
// })

// export const deleteCategory = createAsyncThunk('categories/delete', async (id: string) => {
//   const ref = doc(db, 'categories', id);
//   await deleteDoc(ref);
//   return id;
// });

// export const updateCategory = createAsyncThunk(
//   'categories/update',
//   async ({ id, data }: { id: string; data: any }) => {
//     const ref = doc(db, 'categories', id);
//     await updateDoc(ref, data);
//     return { id, data };
//   }
// );

// const categorySlice = createSlice({
//     name: "categories",
//     initialState: {
//         items: <any>[],
//         loading: false,
//         error: null,
//         image: null,
//         selectedCategory: "",
//     },
//     reducers: {
//         setSelectedCategory: (state, action) => {
//             state.selectedCategory = action.payload;
//         },
//         setImage : (state, action) => {
//             state.image = action.payload.image;
//         },
//         setCategories: (state, action) => {
//             state.items = action.payload;
//         }
        
//     },
//     extraReducers : (builder) => {
//         builder
//         .addCase(fetchCategories.pending, (state) => {
             
//             state.loading =true;            
//         })
//         .addCase(fetchCategories.fulfilled, (state, action) => {
             
//             state.loading = false;
//             state.items = action.payload;
//         })
//         .addCase(fetchCategories.rejected, (state:any, action:any) => {
             
//             state.loading = false;
//             state.items = action.error.message;
//         })
//         .addCase(addCategory.fulfilled, (state, action:any) => {
//             state.items.push(action.payload)
//             state.image = action.payload.image
//         })

//         .addCase(deleteCategories.fulfilled, (state, action) => {
//             state.items = state.items.filter((category:any) => category.id !== action.payload);
//         })
//     }
// }) 

// export const {setImage, setSelectedCategory, setCategories} = categorySlice.actions;
// export default categorySlice.reducer;


import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import { db, storage } from "../../Firebase/firebaseConfig";

// Category type for consistency
interface Category {
  id: string;
  name: string;
  image: string;
  display_order: number;
}

// 🔁 FETCH categories sorted by display_order
export const fetchCategories = createAsyncThunk<Category[], void>(
  "categories/fetchcategories",
  async (_, thunkAPI) => {
    try {
      const querySnapshot = await getDocs(collection(db, "categories"));
      const data: Category[] = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...(doc.data() as Omit<Category, "id">),
      }));

      // ✅ Sort by display_order
      const sortedData = data.sort(
        (a, b) => (a.display_order || 0) - (b.display_order || 0)
      );

      return sortedData;
    } catch (error: any) {
      console.error("Error fetching categories:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// ➕ ADD Category
export const addCategory = createAsyncThunk<Category, any>(
  "categories/addCategories",
  async ({ name, imageFile, base64Image, display_order }, thunkAPI) => {
    try {
      let imageUrl = base64Image;

      if (imageFile) {
        const imageRef = ref(storage, `categories/${uuidv4()}`);
        await uploadBytes(imageRef, imageFile);
        imageUrl = await getDownloadURL(imageRef);
      }

      const categoryData = { name, image: imageUrl, display_order };
      const docRef = await addDoc(collection(db, "categories"), categoryData);

      return { id: docRef.id, ...categoryData };
    } catch (error: any) {
      console.error("Error adding category:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// ❌ DELETE Category
export const deleteCategory = createAsyncThunk<string, string>(
  "categories/delete",
  async (id, thunkAPI) => {
    try {
      await deleteDoc(doc(db, "categories", id));
      return id;
    } catch (error: any) {
      console.error("Error deleting category:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// ✏️ UPDATE Category
export const updateCategory = createAsyncThunk<
  { id: string; data: Partial<Category> },
  { id: string; data: Partial<Category> }
>("categories/update", async ({ id, data }, thunkAPI) => {
  try {
    const refDoc = doc(db, "categories", id);
    await updateDoc(refDoc, data);
    return { id, data };
  } catch (error: any) {
    console.error("Error updating category:", error);
    return thunkAPI.rejectWithValue(error.message);
  }
});

const categorySlice = createSlice({
  name: "categories",
  initialState: {
    items: [] as Category[],
    loading: false,
    error: null as string | null,
    image: null as string | null,
    selectedCategory: "",
  },
  reducers: {
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    setImage: (state, action) => {
      state.image = action.payload.image;
    },
    setCategories: (state, action) => {
      state.items = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // add
      .addCase(addCategory.fulfilled, (state, action) => {
        state.items.push(action.payload);
        state.image = action.payload.image;
      })

      // delete
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.items = state.items.filter(
          (category) => category.id !== action.payload
        );
      })

      // update
      .addCase(updateCategory.fulfilled, (state, action) => {
        const index = state.items.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.items[index] = {
            ...state.items[index],
            ...action.payload.data,
          };
        }
      });
  },
});

export const { setImage, setSelectedCategory, setCategories } =
  categorySlice.actions;

export default categorySlice.reducer;
